import React, { useContext, useState } from 'react';
//import { useNavigate } from "react-router-dom";
import { Box, Button, Header, Text, Menu, Nav, ResponsiveContext, Tip } from 'grommet';
import { Hpe as HpeIcon, Slack as SlackIcon } from 'grommet-icons';
//import { UserContext } from '../helpers';

function goNav(url) {
  window.location.href = url;
}

const items = [
  { label: 'Home', 
    onClick: () => { goNav('/') } ,
    tooltip: 'Explorer home...',
    id: 'home'  
  },   
  { label: 'Innovation', 
    onClick: () => { goNav('/innovation') } ,
    tooltip: 'Innovation info...',
    id: 'inno'  
  },  
  { label: 'AI', 
    onClick: () => { goNav('/ai') } ,
    tooltip: 'AI @ HPE...',
    id: 'AI'  
  },   
  { label: 'Roadmaps', 
    onClick: () => { goNav('/roadmaps') } ,
    tooltip: 'EA roadmaps...',
    id: 'road'  
  },   
  { label: 'Standards', 
    onClick: () => { goNav('/standards') } ,
    tooltip: 'EA standards...',
    id: 'stand'  
  },   
  { label: 'Platforms', 
    onClick: () => { goNav('/platforms') } ,
    tooltip: 'Platform info...',
    id: 'plat'  
  },  
  { label: 'HoH', 
    onClick: () => { goNav('/hoh') } ,
    tooltip: 'HPE on HPE...',
    id: 'hoh'  
  },   
  { label: 'TCP', 
    onClick: () => { goNav('/tcp') } ,
    tooltip: 'TCP info...',
    id: 'tcp'  
  },      
  { label: 'Blog', 
    onClick: () => { goNav('/blog') } ,
    tooltip: 'HPE IT Blog...',
    id: 'plat'  
  },   
  // { label: 'IT Support', 
  //   onClick: () => { goNav('https://myitsupport.ext.hpe.com/ITSHome') } ,
  //   tooltip: 'myITsupport site...',
  //   id: 'issue'  
  // },    
  { 
    icon: (<SlackIcon color="plain" size="large" />),
    onClick: () => { goNav('slack://channel?team=E01LD9FH0JZ&id=C02CLPYRS22') } ,
    tooltip: 'Ask EA Slack channel...',
    id: 'slack' 
  },
];

const AppHeader = () => {

  //const navigate = useNavigate();
  const size = useContext(ResponsiveContext);
 
  const [focused] = useState(false);
  //const [focused, setFocused] = useState(false);

  return (

    <Header fill="horizontal" pad={{ horizontal: 'medium' }} background="background-front">
      <Tip content="Explorer home...">
        <Button onClick={() => { goNav("/"); }}>
          <Box direction="row" align="start" gap="medium" pad={{ vertical: 'small' }} responsive={false}>
            <Box height="24px" justify="center">
              <HpeIcon color="brand"/>
            </Box>
            {(!['xsmall', 'small'].includes(size) ||
              (['xsmall', 'small'].includes(size) && !focused)) && (
              <Box direction="row" gap="xsmall">
                <Text color="text-strong" weight="bold">HPE</Text>
                <Text color="text-strong">Explorer</Text>
              </Box>
            )}
          </Box>
        </Button>
      </Tip>
      {!['xsmall', 'small'].includes(size) ? (
        <Nav direction="row" gap="small">
          {items.map(item => (
            <Tip content={item.tooltip}>
              <Button label={item.label}
                      icon={item.icon}
                      key={item.label} 
                      onClick={item.onClick}/>
            </Tip>  
        ))}

        </Nav>

      ) : (

        <Menu label="Menu" items={items} /> 

      )}
    </Header>
  );
};

export { AppHeader as Header };
